// extracted by mini-css-extract-plugin
export default {"label":"label--reaDw","days":"days--OZMSq","info":"info--Sx_e0"};